



























































import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import i18n from '@/plugins/i18n';

import Field from '@/shared/components/Field/Field.vue';
import KoinDetails from '../Details/KoinDetails.vue';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Field,
    KoinDetails,
  }
})
export default class KoinInstallmentSelect extends Vue {
  @Prop()
  private readonly bankslip: any;

  @CheckoutModule.Getter
  private getOfferPaymentConditionByMethodCode!: any;

  private form: any = {
    installment: null,
  };

  private get paymentConditions() {
    return this.getOfferPaymentConditionByMethodCode(this.bankslip.method).payment_conditions;
  }

  private get paymentConditionBankSlip() {
    return this.paymentConditions && this.paymentConditions.find((value: any) => value.payment_method_code === this.bankslip.method);
  }

  private get koinInstallmentsOptions() {
    return this.paymentConditionBankSlip && this.paymentConditionBankSlip.installments.map((option: any) => {
      return {
        ...option,
        installment_label: this.installmentLabel(option),
        interest_label: this.placeholderInterestAmount(option.interest_per_month),
        text: `${this.installmentLabel(option)} (${this.placeholderInterestAmount(option.interest_per_month)})`,
      };
    });
  }

  private get installmentSelected() {
    return this.paymentConditionBankSlip && this.paymentConditionBankSlip.installments.find((value: any) => value.number === this.form.installment);
  }

  private installmentLabel(installment: any) {
    return `${installment.number}x ${i18n.n(installment.amount, 'currency', 'pt-br')}`;
  }

  private placeholderInterestAmount(amount: number) {
    return amount === 0 ? `+ ${i18n.n(amount, 'percent', 'pt-br')} na parcela` : `+ ${i18n.n((amount/100), 'percent', 'pt-br')} na parcela`;
  }

  private get selectedInCash() {
    return this.form.installment === 1;
  }

  private get showKoinDetails() {
    return !this.selectedInCash && this.form.installment !== null;
  }

  private selectInstallment() {
    this.$emit('setBankSlipInstallment', this.installmentSelected);
  }
}
